import { GroupMode } from '@bringg/types';
import { flattenObject } from '@bringg-frontend/utils';

import { TableDefinition } from 'bringg-web/features/monitoring/shared/stores/groups/table-definition';
import { TableDefinitionData } from '../stores/groups/types';
import { monitoringRootStore } from 'bringg-web/features/monitoring/shared/stores/monitoring-store';

function switchDefinition(data: TableDefinitionData, defaultGrouping: GroupMode) {
	const tableDefinitionStore = monitoringRootStore.getStore().tableDefinitionStore;
	const latestTableDefinition: TableDefinition = tableDefinitionStore.getLatestTableDefinition(data.owner);

	const mergedData: TableDefinitionData = {
		filters: data.filters || latestTableDefinition?.filters,
		sorting: data.sorting || latestTableDefinition?.sorting || { key: 'id', direction: 'asc' },
		groupMode: data.groupMode || latestTableDefinition?.groupMode || defaultGrouping,
		owner: data.owner,
		entityBaseType: data.entityBaseType
	};

	const key = buildKey(mergedData);

	if (tableDefinitionStore.has(key)) {
		tableDefinitionStore.useExisting(key);
		return;
	}

	tableDefinitionStore.add(key, mergedData);
}

function buildKey(data: TableDefinitionData) {
	const flatObject = flattenObject(data);
	return JSON.stringify(flatObject, Object.keys(flatObject).sort());
}

export const tableDefinitionSwitcher = { switch: switchDefinition };
